import { centralCountryApi } from "api/Country/api.ts";
import { useQueryApi } from "api/hooks.ts";

import GetCountriesResponse = App.Http.Responses.Country.GetCountriesResponse;

export const useGetCentralCountriesQuery = (options = {}) =>
    useQueryApi<GetCountriesResponse>({
        queryKey: ["getCentralCountries"],
        queryFn: () => centralCountryApi.index(),
        ...options,
    });
